import { render, staticRenderFns } from "./putOut.vue?vue&type=template&id=a20aef42&scoped=true&"
import script from "./putOut.vue?vue&type=script&lang=js&"
export * from "./putOut.vue?vue&type=script&lang=js&"
import style0 from "./putOut.vue?vue&type=style&index=0&id=a20aef42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20aef42",
  null
  
)

export default component.exports